import { render, staticRenderFns } from "./MShowProduct.vue?vue&type=template&id=2d21b2dc&scoped=true&"
import script from "./MShowProduct.vue?vue&type=script&lang=js&"
export * from "./MShowProduct.vue?vue&type=script&lang=js&"
import style0 from "./MShowProduct.vue?vue&type=style&index=0&id=2d21b2dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21b2dc",
  null
  
)

export default component.exports